export const DRAFT_SET = 'DRAFT_SET';
export const DRAFT_UNSET = 'DRAFT_UNSET';
export const DRAFT_LOADING = 'DRAFT_LOADING';
export const DRAFT_LOADED = 'DRAFT_LOADED';

